import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const baseIncluded = ['Sistema 360 Lash', '6 tomos estratégicos', 'Acceso inmediato', 'Formato digital PDF'];
const baseExcluded = ['Bono 1: Pack de Scripts WhatsApp', 'Bono 2: Fichero Técnico de Clientas', 'Bono 3: Checklist Operativo Diario', 'Bono 4: Kit de Políticas', 'Bono 5: Planner Semanal', 'Bono 6: Hojas de Costos', 'Acelerador Profesional'];
const completeItems = ['📘 Sistema 360 Lash', '📚 6 tomos estratégicos', '⚡ Acceso inmediato', '📄 Formato digital PDF', '💬 Bono 1: Pack de Scripts WhatsApp', '🗂️ Bono 2: Fichero Técnico de Clientas', '✅ Bono 3: Checklist Operativo Diario', '📋 Bono 4: Kit de Políticas', '🗓️ Bono 5: Planner Semanal', '💸 Bono 6: Hojas de Costos', '🚀 Acelerador Profesional'];
export function Offer() {
  return <section id="oferta" className="pt-12 md:pt-20 pb-28 md:pb-20 bg-white scroll-mt-10" data-id="element-136">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-138">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4" data-id="element-139">
            Empezá hoy a ordenar tu negocio de pestañas
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-8 max-w-5xl mx-auto items-stretch" data-id="element-140">
          {/* Option 1: Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-ocean-cream rounded-2xl md:rounded-3xl border border-gray-100 shadow-sm flex flex-col h-full p-4 md:p-8" data-id="element-141">
            <h3 className="text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center" data-id="element-142">
              Kit Base
            </h3>

            <ul className="space-y-2 md:space-y-4 mb-4 md:mb-8 flex-1 text-sm md:text-base" data-id="element-143">
              {baseIncluded.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-144">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-ocean-teal shrink-0 mt-0.5" data-id="element-145" />
                  <span className="text-gray-700" data-id="element-146">{item}</span>
                </li>)}
              {baseExcluded.map((item, i) => <li key={i} className="hidden sm:flex items-start gap-2 md:gap-3 opacity-40" data-id="element-147">
                  <div className="w-4 h-4 md:w-5 md:h-5 shrink-0" data-id="element-148" />
                  <span className="text-gray-500 line-through" data-id="element-149">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-4 md:mb-8" data-id="element-150">
              <div className="text-xs md:text-base text-gray-500 line-through mb-1" data-id="element-151">
                Valor normal: $34.990
              </div>
              <div className="text-2xl md:text-4xl font-bold text-gray-900" data-id="element-152">
                Hoy: $19.990
              </div>
            </div>

            <a href="https://www.tera-ventasonline.shop/cart/45111904567411:1" target="_blank" rel="noopener noreferrer" className="w-full py-3 px-3 md:py-4 md:px-6 bg-white border-2 border-ocean-teal text-ocean-teal hover:bg-ocean-teal-light rounded-xl font-bold text-sm md:text-lg transition-colors text-center block" data-id="element-153">
              QUIERO EL KIT BASE
            </a>
          </motion.div>

          {/* Option 2: Complete */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-2xl md:rounded-3xl border-2 border-ocean-teal shadow-soft-lg relative flex flex-col h-full p-4 md:p-8" data-id="element-154">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-ocean-gold text-white px-3 md:px-4 py-1 rounded-full text-[11px] md:text-sm font-bold uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-155">
              ⭐ Más elegido
            </div>

            <h3 className="text-lg md:text-2xl font-bold mb-4 md:mb-6 text-center text-ocean-teal-dark mt-2 md:mt-1" data-id="element-156">
              Kit Completo
            </h3>

            <ul className="space-y-2 md:space-y-4 mb-4 md:mb-8 flex-1 text-sm md:text-base" data-id="element-157">
              {completeItems.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-158">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-ocean-gold-dark shrink-0 mt-0.5" data-id="element-159" />
                  <span className="text-gray-900 font-medium" data-id="element-160">{item}</span>
                </li>)}
            </ul>

            <div className="text-center mb-4 md:mb-8" data-id="element-161">
              <div className="text-xs md:text-base text-gray-500 line-through mb-1" data-id="element-162">
                Valor normal: $47.990
              </div>
              <div className="text-2xl md:text-5xl font-bold text-ocean-teal-dark" data-id="element-163">
                Hoy: $27.990
              </div>
            </div>

            <motion.a href="https://www.tera-ventasonline.shop/cart/45111856431219:1" target="_blank" rel="noopener noreferrer" animate={{
            scale: [1, 1.04, 1]
          }} transition={{
            repeat: Infinity,
            duration: 1.8,
            ease: 'easeInOut'
          }} className="w-full py-3 px-3 md:py-4 md:px-6 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-sm md:text-lg transition-colors shadow-lg text-center block" data-id="element-164">
              QUIERO EL SISTEMA 360 LASH COMPLETO
            </motion.a>
          </motion.div>
        </div>

        <div className="text-center mt-8 text-sm font-medium text-red-600" data-id="element-165">
          Oferta de lanzamiento por tiempo limitado
        </div>
      </div>
    </section>;
}